import { useToast } from "contexts/ToastContext";
import { useEffect, useRef, useState } from "react";
import { LoadingPageIcon } from "utils/constant";
import { useTranslation } from "react-i18next";

import { useParams } from "react-router-dom";
import { getStakeholder } from "services/getEmployees";
import { useAuth } from "contexts/AuthContext";
import RegistrarLegislativeDraft from "./registrarLegislativeDraft";
import { CanShow, LEGISLATIVE_DRAFTING_UI_RULES } from "utils/authRules";
import { getLawImplementation } from "services/lawImplementationService";
import LegalAwarenessCreationDetail from "./fragments/leftPanel";
import LegalAwarenessCreationRightPanel from "./fragments/rightPanel";
import { getLegalAwareness, getLegalAwarenessZone, getSingleLegalAwareness } from "services/legalAwarenessService";
import LegalAwarenessZone from "pages/lawImplementation/fragments/leftPanelZone";
import ZoneImplementationGuide from "./fragments/zoneImplementationGuide";

const SingleLegalAwarenessCreationZone = () => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const [data, setData] = useState({
        isLoading: true, status: "", forward_status: "",
    });
    const { id } = useParams<{ id: string }>();
    const contextData = useAuth();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getLegalAwarenessZone(id || "");
                console.log("zone:", response);
                let user = null;
                if (response.requested_by_id && response.requested_by !== "internal") {
                    try {
                        user = await getStakeholder(response.requested_by_id, contextData.token || contextData?.user?.access_token || "");
                    } catch (err) {
                        console.error("Error fetching stakeholder:", err);
                        showToast(t("FailedToFetchStakeholder") || "Failed to fetch stakeholder", "error");
                    }
                }
                setData({
                    isLoading: false,
                    ...response,
                    requested_by_user: user,
                });
            } catch (error) {
                console.error("Error fetching legal research request:", error);
                showToast(t("FailedToFetchLegalResearchRequest") || "Failed to fetch legal research request.", "error");
                setData((prev) => ({ ...prev, isLoading: false }));
            }
        };

        fetchData();
    }, [id, contextData.token, contextData?.user?.access_token, showToast, t]);

    if (data.isLoading)
        return (
            <div className="flex justify-center items-center h-64">
                {LoadingPageIcon}
            </div>
        );

    const isZonal = contextData?.user?.roles?.some(
        (r: string) => r === "ZonalLRD" || r === "ZonalLIF"
    );

    return (
        <div className="flex h-full bg-gray-100 p-2">
            <LegalAwarenessZone request={data} />
            {isZonal
                ? <ZoneImplementationGuide variant="zone" data={data} />
                : <LegalAwarenessCreationRightPanel request={data} />}
        </div>
    );
};

export default SingleLegalAwarenessCreationZone;